export const theme = {
  primary: {
    600: "#3F80EA",
    900: "#293042"
  },
  grey: { 300: "#d1d1d1" },
  white: "#fff",
  green: {
    300: "#2c7a7b"
  },
  scrollbar: {
    border: "#ffffff",
    thumb: {
      bg: "#e1e1e1"
    }
  },
  loader: {
    teal: "#5DDADB",
    purple: "#3437A2",
    pink: "#F78EB6",
    bg: "#171923db"
  },
  gradient: {
    blue: {
      300: "#366dc7",
      600: "#366dc7",
      900: "#366dc7"
    }
  },

  text: {
    grey: {
      300: "#a0aec0",
      500: "#e1e1e1"
    }
  },

  timeline: {
    divider: {
      bg: "#718096"
    }
  }
};
